import type { Module } from 'vuex';
import { Locale } from '@/types/Locale';
import {RootState} from "@/store";

export interface LocalesState {
  locales: Locale[];
  formatDate: string[];
  formatTime: string[];
  formatNumber: string[];
  formatAddress: string[];
  formatTelephone: string[];
  metric: string[];
  collation: string[];
  firstWeekDays: string[];
  timezones: string[];
}

const localesModule: Module<LocalesState, RootState> = {
  namespaced: true,

  state: (): LocalesState => ({
    locales: [],
    formatDate: [],
    formatTime: [],
    formatNumber: [],
    formatAddress: [],
    formatTelephone: [],
    metric: [],
    collation: [],
    firstWeekDays: [],
    timezones: [],
  }),

  mutations: {
    setLocales(state, payload: { locales: Record<number, any> }) {
      state.locales = Object.values(payload.locales).map(raw => Locale.fromRaw(raw));
    },

    setLocaleCreate(state, payload: any) {
      state.locales.push(Locale.fromRaw(payload));
    },

    setLocaleUpdate(state, payload: any) {
      const idx = state.locales.findIndex(locale => locale.idLocale === payload.idLocale);
      if (idx === -1) return;
      state.locales[idx] = { ...state.locales[idx], ...payload };
    },

    setLocaleDelete(state, payload: { idLocale: number }) {
      state.locales = state.locales.filter(locale => locale.idLocale !== payload.idLocale);
    },

    setLocaleLock(state, payload: { idLocale: number }) {
      const locale = state.locales.find(locale => locale.idLocale === payload.idLocale);
      if (locale) locale.locked = true;
    },

    setLocaleUnlock(state, payload: { idLocale: number }) {
      const locale = state.locales.find(locale => locale.idLocale === payload.idLocale);
      if (locale) locale.locked = false;
    },

    setLocaleConfiguration(state, payload: { [key: string]: string[] }) {
      state.formatDate = payload.formatDate || [];
      state.formatTime = payload.formatTime || [];
      state.formatNumber = payload.formatNumber || [];
      state.formatAddress = payload.formatAddress || [];
      state.formatTelephone = payload.formatTelephone || [];
      state.metric = payload.metric || [];
      state.collation = payload.collation || [];
      state.firstWeekDays = payload.firstWeekDays || [];
      state.timezones = payload.timezones || [];
    },
  },
  actions: {
    wsSetLocales({ commit }, payload) {
      commit('setLocales', payload);
    },
    wsLocaleCreate({ commit }, payload) {
      commit('setLocaleCreate', payload);
    },
    wsLocaleUpdate({ commit }, payload) {
      commit('setLocaleUpdate', payload);
    },
    wsLocaleDelete({ commit }, payload) {
      commit('setLocaleDelete', payload);
    },
    wsLocaleLock({ commit }, payload) {
      commit('setLocaleLock', payload);
    },
    wsLocaleUnlock({ commit }, payload) {
      commit('setLocaleUnlock', payload);
    },
    wsSetLocaleConfiguration({ commit }, payload) {
      commit('setLocaleConfiguration', payload);
    },
  },
};

export default localesModule;